var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEthereal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 28,
    viewBox: "0 0 96 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_395_2670)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.16546 11.4127C1.73458 11.4127 0.311035 9.90697 0.311035 8.17104C0.311035 7.2769 0.626185 6.33412 1.75075 5.57319C0.708303 4.84589 0.360778 3.98537 0.360778 3.12609C0.360778 1.48853 1.73458 0.000305176 4.1156 0.000305176H6.68413C8.48759 0.000305176 10.1252 0.893208 10.637 2.94438H9.09887C8.68542 1.8521 7.77641 1.38876 6.68413 1.38876H4.1156C2.77556 1.38876 1.85028 2.09996 1.85028 3.12609C1.85028 4.26684 2.74331 4.91188 4.1156 4.91188H7.97655V6.28439H4.16546C2.72716 6.28439 1.80054 7.01293 1.80054 8.1873C1.80054 9.26192 2.77556 10.0228 4.16546 10.0228H6.7366C7.86114 10.0228 8.70416 9.60923 9.16749 8.46863H10.7054C10.1936 10.5023 8.57233 11.4127 6.7366 11.4127H4.16546Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7966 11.1977V6.40059H26.9184V11.1977H25.4302V0.215027H26.9184V5.01228H33.7966V0.215027H35.2861V11.1977H33.7966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5278 11.1977H47.1258V9.80796H40.016V6.40057C39.194 6.40057 38.5278 7.06683 38.5278 7.88879V11.1977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1258 1.60473V0.215027H38.5278V3.52407C38.5278 4.34586 39.194 5.01228 40.016 5.01228V1.60473H47.1258Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0161 6.40058H46.7039V5.01227H40.0161V6.40058Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3451 1.6047H51.8563V5.27592H56.3451C57.5357 5.27592 58.3626 4.63071 58.3626 3.44022C58.3626 2.24958 57.5357 1.6047 56.3451 1.6047ZM56.6926 6.66561L60.1484 11.1973H58.2966L54.8395 6.66561H51.8563V11.1973H50.3682V0.214844H56.3451C58.4125 0.214844 59.8506 1.37295 59.8506 3.44022C59.8506 5.39162 58.5606 6.53378 56.6926 6.66561Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8862 11.1977H71.4842V9.80796H64.3743V6.40057C63.5525 6.40057 62.8862 7.06683 62.8862 7.88879V11.1977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4842 1.6047V0.214996H62.8862V3.52404C62.8862 4.34583 63.5525 5.0121 64.3743 5.0121V1.6047H71.4842Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.374 6.40058H71.0618V5.01212H64.374V6.40058Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.227 1.83648L76.8621 7.27737H81.5933L79.227 1.83648ZM75.1584 11.1975H73.6206L78.45 0.214874H80.0714L84.8847 11.1975H83.297L82.1886 8.65097H76.267L75.1584 11.1975Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5091 9.80783H95.8043V11.1975H87.021V0.214874H88.5091V9.80783Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7031 0.215179V1.60504H18.5043V11.1978H17.016V1.60504H12.8174V0.215179H22.7031Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.561 16.6884H52.0505V23.123C52.0505 25.3558 53.3071 26.4966 55.3258 26.4966C57.3432 26.4966 58.5998 25.3558 58.5998 23.123V16.6884H60.0879V23.123C60.0879 26.1827 58.2025 27.8865 55.3258 27.8865C52.4478 27.8865 50.561 26.1827 50.561 23.123V16.6884Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8668 16.6889V18.0788H43.668V27.6718H42.1799V18.0788H37.981V16.6889H47.8668Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.287 16.6888V27.6714H33.6158L26.917 18.8059V27.6714H25.4287V16.6888H27.0987L33.7975 25.5545V16.6888H35.287Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2015 24.9425C88.6972 25.8854 89.8876 26.4966 91.3434 26.4966C93.0133 26.4966 94.2053 25.7196 94.2053 24.6609C94.2053 23.6186 93.4444 23.0893 91.8728 22.9237L89.9536 22.7258C87.7881 22.494 86.8777 21.3196 86.8777 19.7655C86.8777 17.8303 88.4992 16.4742 91.1119 16.4742C93.808 16.4742 95.2801 18.078 95.7432 19.4182H94.1217C93.6922 18.5078 92.4842 17.8627 91.0619 17.8627C89.3422 17.8627 88.3658 18.7071 88.3658 19.6982C88.3658 20.7084 89.1105 21.2376 90.4009 21.3696L92.4681 21.5837C94.4855 21.7992 95.6934 22.9573 95.6934 24.5774C95.6934 26.2153 94.2215 27.8865 91.3434 27.8865C88.4492 27.8865 87.0757 26.3646 86.5801 24.9425H88.2015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3706 27.6717H83.9686V26.2818H76.8589V22.8745C76.037 22.8745 75.3706 23.5408 75.3706 24.3627V27.6717Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9686 18.0786V16.6889H75.3706V19.9978C75.3706 20.8198 76.037 21.4859 76.8589 21.4859V18.0786H83.9686Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8589 22.8745H83.5466V21.4859H76.8589V22.8745Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.958 18.0783H64.469V21.7495H68.958C70.1485 21.7495 70.9753 21.1044 70.9753 19.914C70.9753 18.7235 70.1485 18.0783 68.958 18.0783ZM69.3055 23.1395L72.7612 27.6712H70.9094L67.4522 23.1395H64.469V27.6712H62.981V16.6886H68.958C71.0252 16.6886 72.4636 17.8467 72.4636 19.914C72.4636 21.8654 71.1733 23.0075 69.3055 23.1395Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6157 27.6717H22.2137V26.2818H15.104V22.8745C14.2821 22.8745 13.6157 23.5408 13.6157 24.3627V27.6717Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2137 18.0786V16.6889H13.6157V19.9978C13.6157 20.8198 14.2821 21.4859 15.104 21.4859V18.0786H22.2137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.104 22.8745H21.7916V21.4859H15.104V22.8745Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0161 16.6886L7.35328 27.1724C7.24903 27.4712 6.96709 27.6712 6.65076 27.6712H5.5083L9.42815 16.6886H11.0161Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.35742 21.3857H4.65927L4.16943 20.013H6.84741L6.35742 21.3857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.58832 16.6886L5.50808 27.6712H4.36563C4.04933 27.6712 3.76753 27.4712 3.66309 27.1724L0.000488281 16.6886H1.58832Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_395_2670"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 95.8506,
    height: 28,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereal);
export default __webpack_public_path__ + "static/media/ethereal.87f9eb0c1539ce865e5be026097d872d.svg";
export { ForwardRef as ReactComponent };